import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Assessment from '@/models/Assessment.js'

export const useAssessmentStore = defineStore('assessmentStore', () => {
  let syncableModel = useSyncableModel(useApiResource('assessments'), {
    className: Assessment.modelName.name,
    paramKey: Assessment.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
